import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './pages/Dashboard';
import VehicleHealth from './pages/VehicleHealth';
import VehicleDetails from './pages/VehicleDetails';
import Orders from './pages/Orders';
import 'flatpickr/dist/flatpickr.min.css';
//import './styles/tailwind.css';

import './index.css';
import './styles/styles.css';

const App = () => {
  
  const [isLoggedIn, setIsLoggedIn] = useState(
    !!localStorage.getItem("tensor-auth-token")
  );

  if (process.env.NODE_ENV === "development") {
    console.log("Running in development mode");
  } else if (process.env.NODE_ENV === "production") {
    console.log("Running in production mode");
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login setIsLoggedIn={setIsLoggedIn} />} />

        {/* Protected Routes */}
        {isLoggedIn ? (
          <>
            <Route path="/fleet" element={<Dashboard />} />
            <Route path="/vehicle/:id" element={<VehicleDetails />} />
            <Route path="/vehicle-health" element={<VehicleHealth />} />
            <Route path="/orders" element={<Orders />} />
          </>
        ) : (
          <>
            <Route path="/fleet" element={<Navigate to="/" />} />
            <Route path="/vehicle-health" element={<Navigate to="/" />} />
            <Route path="/orders" element={<Navigate to="/" />} />
          </>
        )}
      </Routes>
    </Router>
  );
};

export default App;
